import React, {Component} from 'react';
import PropTypes from "prop-types";
import classnames from "classnames";
import validator from "validator";
import {connect} from "react-redux";
import {inviteCompanyUser} from "../../store/actions/user";
import {checkUniqueEmail} from "../../store/actions/auth";

class AddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: {
        value: '',
        isValid: false,
        errorMessage: '',
        touched: false
      },
      last_name: {
        value: '',
        isValid: false,
        errorMessage: '',
        touched: false
      },
      email: {
        value: '',
        isValid: false,
        errorMessage: '',
        touched: false
      },
      role: {
        value: 'general'
      },
      formValid: false
    };
    this.handleUserInput = this.handleUserInput.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.invitedAdmin) {
      this.props.closeModal(nextProps.invitedAdmin);
      return;
    }

    if (nextProps.errors) {
      this.setState({
        email: {
          ...this.state.email,
          isValid: false,
          errorMessage: 'This email address already exists'
        }
      });
    }
  }

  handleUserInput(ev) {
    const fieldName = ev.target.name;
    const value = ev.target.value;

    this.setState({
      [fieldName]: {
        ...this.state[fieldName],
        value
      }
    }, () => this.validateField(fieldName, value));
  }

  validateField(fieldName, value) {
    let emailValid = this.state.email.isValid;
    let emailErrorMessage = this.state.email.errorMessage;
    let firstNameValid = this.state.first_name.isValid;
    let firstNameErrorMessage = this.state.first_name.errorMessage;
    let lastNameValid = this.state.last_name.isValid;
    let lastNameErrorMessage = this.state.last_name.errorMessage;

    let isValid = false;
    let errorMessage = '';

    switch (fieldName) {
      case 'email':
        emailValid = validator.isEmail(value);
        emailErrorMessage = 'Entered email address is wrong.';
        isValid = emailValid;
        errorMessage = emailErrorMessage;
        break;
      case 'first_name':
        firstNameValid = !validator.isEmpty(value);
        firstNameErrorMessage = 'First Name is required.';
        isValid = firstNameValid;
        errorMessage = firstNameErrorMessage;
        break;
      case 'last_name':
        lastNameValid = !validator.isEmpty(value);
        lastNameErrorMessage = 'Last Name is required.';
        isValid = lastNameValid;
        errorMessage = lastNameErrorMessage;
        break;
      default:
        break;
    }

    this.setState({
      [fieldName]: {
        ...this.state[fieldName],
        isValid,
        errorMessage
      }
    }, this.validateForm);
  }

  validateForm() {
    const {email, first_name, last_name} = this.state;

    this.setState({
      formValid: email.isValid && first_name.isValid && last_name
    });
  }

  handleInputBlur(ev) {
    const name = ev.target.name;

    this.setState({
      [name]: {
        ...this.state[name],
        touched: !!ev.target.value
      }
    });
  }

  onSubmit(ev) {
    ev.preventDefault();
    const {first_name, last_name, email, role, formValid} = this.state;
    if (formValid) {
      const requestBody = {
        last_name: last_name.value,
        first_name: first_name.value,
        email: email.value
      };

      if (!this.props.addingWarehouse) {
        requestBody.role = this.props.addingWarehouse ? 'warehouse' : role.value;
        this.props.inviteCompanyUser(requestBody, this.props.closeModal);
      } else {
        this.props.checkUniqueEmail(requestBody);
      }
    }
  }

  render() {
    const {email, first_name, last_name, role} = this.state;
    const roleSelector = (
        <div className="form-group">
          <label htmlFor="user-role">User role</label>
          <select className="form-control" name="role" id="user-role" value={role.value}
                  onChange={this.handleUserInput}>
            <option value="general">General User</option>
            <option value="warehouse">Warehouse Admin</option>
          </select>
        </div>
    );

    return (
        <div className="popup">
          <div className="btn-close">
            <button onClick={() => this.props.closeModal('add')} className="btn btn-link"><i
                className="icon-close"> </i></button>
          </div>
          <div className="container">
            <div className="row justify-content-center">
              <form className="col-md-8" onSubmit={this.onSubmit.bind(this)}>
                <div className="form-title">
                  <h1>Add user</h1>
                </div>
                <div className={classnames('form-group', {'invalid': !first_name.isValid && first_name.touched})}>
                  <input type="text" className="form-control" placeholder="User first name *" name="first_name"
                         value={first_name.value} onChange={this.handleUserInput} onBlur={this.handleInputBlur}/>
                  {!first_name.isValid && first_name.touched && (
                      <p className="error-msg">{first_name.errorMessage}</p>)}
                </div>
                <div className={classnames('form-group', {'invalid': !last_name.isValid && last_name.touched})}>
                  <input type="text" className="form-control" placeholder="User last name *" name="last_name"
                         value={last_name.value} onChange={this.handleUserInput} onBlur={this.handleInputBlur}/>
                  {!last_name.isValid && last_name.touched && (
                      <p className="error-msg">{last_name.errorMessage}</p>)}
                </div>
                <div
                    className={classnames('form-group', {'invalid': (!email.isValid && email.touched)})}>
                  <input type="email" className="form-control" placeholder="Email address *" name="email"
                         value={email.value} onChange={this.handleUserInput} onBlur={this.handleInputBlur}/>
                  {((!email.isValid && email.touched)) && (
                      <p className="error-msg">{email.errorMessage}</p>)}
                </div>
                {!this.props.addingWarehouse && roleSelector}
                <div className="form-group text-right mb-4">
                  <button type="button" className="btn btn-lg btn-secondary mr-3"
                          onClick={() => this.props.closeModal('add')}>Cancel
                  </button>
                  <input type="submit" className="btn btn-lg btn-primary" value="Add" disabled={!this.state.formValid}/>
                </div>
              </form>
            </div>
          </div>
        </div>
    );
  }
}

AddUser.propTypes = {
  closeModal: PropTypes.func.isRequired,
  inviteCompanyUser: PropTypes.func.isRequired,
  errors: PropTypes.any,
  addingWarehouse: PropTypes.bool,
  checkUniqueEmail: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  inviteCompanyUser: (userData, closeModal) => dispatch(inviteCompanyUser(userData, closeModal)),
  checkUniqueEmail: email => dispatch(checkUniqueEmail(email))
});

const mapStateToProps = state => ({
  errors: state.user.errors,
  invitedAdmin: state.warehouse.invitedAdmin
});

export default connect(mapStateToProps, mapDispatchToProps)(AddUser);



// WEBPACK FOOTER //
// ./src/components/popups/AddUser.jsx